"use strict";

(function (_document$querySelect) {
  var tabSliders = document.querySelectorAll('.tab_slider');
  var desktopStart = parseInt((_document$querySelect = document.querySelector('[data-desktop-start]')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.dataset.desktopStart) || 900;
  var isDesktop = function isDesktop() {
    return window.innerWidth >= desktopStart;
  };
  var noHashUrl = function noHashUrl() {
    return window.location.href.replace(/#.*$/, '');
  };
  var KEYCODE_SPACE = 32;
  if (tabSliders.length > 0) {
    tabSliders.forEach(function (tabSlider) {
      var tabs = tabSlider.querySelectorAll('.tab_slider__tab_item');
      var arrowLeft = tabSlider.querySelector('.arrow_left');
      var arrowRight = tabSlider.querySelector('.arrow_right');
      var menu = tabSlider.querySelector('.tab_slider__menu_input');
      var menuButton = tabSlider.querySelector('.tab_slider__menu_button');
      var currentTab = tabSlider.querySelector('.tab_slider__tab_item.checked') && 0;
      var tabSet = [];
      var sliderTabStep = function sliderTabStep(step) {
        var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var newTab = target ? step : currentTab + step;
        if (newTab <= 0) {
          newTab = 0;
          arrowLeft && arrowLeft.classList.contains('arrow_active') && arrowLeft.classList.remove('arrow_active');
        } else {
          arrowLeft && !arrowLeft.classList.contains('arrow_active') && arrowLeft.classList.add('arrow_active');
        }
        if (newTab >= tabSet.length - 1) {
          newTab = tabSet.length - 1;
          arrowRight && arrowRight.classList.contains('arrow_active') && arrowRight.classList.remove('arrow_active');
        } else {
          arrowRight && !arrowRight.classList.contains('arrow_active') && arrowRight.classList.add('arrow_active');
        }
        sliderMove(newTab);
      };
      var sliderMove = function sliderMove(current) {
        var tabId = tabSet[current];
        tabSet.forEach(function (item) {
          var isCurrent = item === tabId;
          var tab = tabSlider.querySelector('[data-target-content-id=' + item + ']');
          var content = tabSlider.querySelector('[data-content-id=' + item + ']');

          // tab.setAttribute('tabindex', isCurrent || !isDesktop() ? '-1' : '0');
          // content.setAttribute('tabindex', isCurrent ? '0' : '-1');
          tab.classList.toggle('checked', isCurrent);
          tab.setAttribute('aria-selected', isCurrent ? 'true' : 'false');
          content.classList.toggle('checked', isCurrent);
        });
        tabSlider.querySelector('[data-target-content-id=' + tabId + ']').focus();
        currentTab = current;
      };
      if (tabs.length > 0) {
        tabs.forEach(function (tab, index) {
          tabSet[index] = tab.dataset.targetContentId;
          var tabContent = document.querySelector('[data-content-id=' + tab.dataset.targetContentId + ']');
          var tabCurrency = tabContent.querySelectorAll('.shop__currency_filters');
          tab.addEventListener('click', function () {
            sliderTabStep(index, true);
            !isDesktop() && menu.classList.remove('checked');
          });
          tab.addEventListener('keydown', function (e) {
            if (e.key === ' ' || e.keyCode === KEYCODE_SPACE) {
              e.preventDefault();
              tab.click();
            }
          });
          tabCurrency && tabCurrency.forEach(function (currency) {
            currency.action = noHashUrl() + '#' + currency.closest('section.cp').id;
          });
        });
      }
      if (arrowLeft && arrowRight) {
        arrowLeft.addEventListener('click', function (arrow) {
          return arrow.target.classList.contains('arrow_active') && sliderTabStep(-1);
        });
        arrowRight.addEventListener('click', function (arrow) {
          return arrow.target.classList.contains('arrow_active') && sliderTabStep(1);
        });
        [arrowLeft, arrowRight].forEach(function (arrow) {
          return arrow.addEventListener("keydown", function (event) {
            switch (event.keyCode) {
              case 13:
              case 32:
                event.preventDefault();
                arrow.click();
                break;
            }
          });
        });
      }
      var setTabs = function setTabs() {
        return tabs.forEach(function (tab) {
          return tab.setAttribute('tabindex', tab.classList.contains('checked') ? '-1' : '0');
        });
      };
      menuButton && menuButton.addEventListener('click', function () {
        return !isDesktop() && setTabs();
      });
      !isDesktop() && tabs.forEach(function (tab) {
        return tab.setAttribute('tabindex', '-1');
      });
      tabSlider.addEventListener('keydown', function (event) {
        switch (event.keyCode) {
          case 37:
            sliderTabStep(-1);
            break;
          case 39:
            sliderTabStep(1);
            break;
        }
      });
    });
  }
  var openTabHandler = function openTabHandler(target) {
    if (!!target) {
      target.click();
    }
    return true;
  };
  var openTabByHash = function openTabByHash(hash) {
    var element = document.getElementById(hash.split('#')[1]);
    if (element) {
      var parent = element.closest('section.tab_panel');
      if (!parent && !!element.dataset.targetContentId) {
        openTabHandler(element);
      } else if (parent && !!parent.dataset.contentId) {
        var tab = document.querySelector('[data-target-content-id=' + parent.dataset.contentId + ']');
        tab && openTabHandler(tab);
      }
      document.addEventListener('readystatechange', function (e) {
        return e.target.readyState === 'complete' && hash.length > 0 && element.scrollIntoView({
          block: 'start',
          behavior: 'smooth',
          inline: 'center'
        });
      });
    }
    return true;
  };
  window.onhashchange = function () {
    return openTabByHash(window.location.hash);
  };
  document.addEventListener('readystatechange', function (e) {
    e.target.readyState === 'interactive' && window.location.hash.length > 0 && openTabByHash(window.location.hash);
  });
})();